import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { AdminProvider } from '@/contexts/AdminContext';
import { PostsProvider } from '@/contexts/PostsContext';

declare const __BASE_PATH__: string;

const App = () => (
  <LanguageProvider>
    <AdminProvider>
      <PostsProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </PostsProvider>
    </AdminProvider>
  </LanguageProvider>
);

export default App;
